import { render, staticRenderFns } from "./ReservationHistoryPopup.vue?vue&type=template&id=67f3dfc4&scoped=true&"
import script from "./ReservationHistoryPopup.vue?vue&type=script&lang=js&"
export * from "./ReservationHistoryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f3dfc4",
  null
  
)

export default component.exports